module.exports = __webpack_public_path__ + "static/aws-a9bfa2354716e5f648dd21f71b049ea7.png";